var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptycartimage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 198,
    viewBox: "0 0 264 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4568 180.735C26.3645 191.706 38.9027 196.415 38.9027 196.415C38.9027 196.415 41.8627 183.338 35.955 172.368C30.0473 161.397 17.5091 156.688 17.5091 156.688C17.5091 156.688 14.5491 169.765 20.4568 180.735Z",
    fill: "#2F2E41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5172 177.126C35.183 183.552 39.2907 196.314 39.2907 196.314C39.2907 196.314 26.1058 198.659 15.44 192.234C4.77424 185.808 0.666504 173.046 0.666504 173.046C0.666504 173.046 13.8514 170.701 24.5172 177.126Z",
    fill: "#445FD2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M172.767 175.712H60.2139V174.902H171.957V135.579H69.6759L64.7072 125.214L65.4373 124.863L70.1855 134.767H172.767V175.712Z",
    fill: "#2F2E41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1936 195.577C79.8892 195.577 83.6958 191.765 83.6958 187.063C83.6958 182.362 79.8892 178.55 75.1936 178.55C70.498 178.55 66.6914 182.362 66.6914 187.063C66.6914 191.765 70.498 195.577 75.1936 195.577Z",
    fill: "#3F3D56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M159.001 195.577C163.697 195.577 167.503 191.765 167.503 187.063C167.503 182.362 163.697 178.55 159.001 178.55C154.306 178.55 150.499 182.362 150.499 187.063C150.499 191.765 154.306 195.577 159.001 195.577Z",
    fill: "#3F3D56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M257.789 11.5281C260.695 11.5281 263.052 9.16858 263.052 6.25798C263.052 3.34737 260.695 0.987854 257.789 0.987854C254.882 0.987854 252.525 3.34737 252.525 6.25798C252.525 9.16858 254.882 11.5281 257.789 11.5281Z",
    fill: "#3F3D56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M184.805 122.2H58.2947L30.9209 32.6086H212.996L212.83 33.1357L184.805 122.2ZM58.8937 121.39H184.211L211.892 33.4194H32.0153L58.8937 121.39Z",
    fill: "#2F2E41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M174.929 117.538H63.811L39.7676 38.0812H199.69L199.545 38.5491L174.929 117.538Z",
    fill: "#F2F2F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M215.264 24.6046L214.481 24.3966L219.824 4.2309H250.906V5.04191H220.447L215.264 24.6046Z",
    fill: "#2F2E41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M203.897 59.7698H39.7671V60.5806H203.897V59.7698Z",
    fill: "#2F2E41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M194.498 89.6407H48.8936V90.4515H194.498V89.6407Z",
    fill: "#2F2E41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M122.361 33.0139H121.551V121.795H122.361V33.0139Z",
    fill: "#2F2E41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M158.614 32.9885L152.801 121.767L153.609 121.82L159.422 33.0415L158.614 32.9885Z",
    fill: "#2F2E41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3145 32.9875L84.5063 33.0402L90.2852 121.821L91.0933 121.769L85.3145 32.9875Z",
    fill: "#2F2E41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M244.632 196.091H0.666504V197.043H244.632V196.091Z",
    fill: "#2F2E41"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptycartimage);
export default __webpack_public_path__ + "static/media/emptycartimage.6f2a8c8355bd56053c74d0cbd26f75bf.svg";
export { ForwardRef as ReactComponent };